import { createSlice } from "@reduxjs/toolkit";

export const helpdeskSlice = createSlice({
  name: "helpdesk",
  initialState: {
    usercase: [],
    rpcase:[],    
    typeuser: [],
    fini: '',
    ffin: '',
    isAdmin: false,
    agente:[],
    admin:[],
    casoSeleccionado: [],
    casoNivelesSeleccionado: "",
    detallesCaso: [],
    organizaciones: [],
    dependencias: [],
    matchGA: true,
    formulario: "",
    type_msj: [],
    formInfo: {},
    prioridades: [],
    userreasignacioncaso: [],
    loadingHD: false
  },
  reducers: {
    setLoadingHD: (state, { payload }) => {
      state.loadingHD = payload;
    },
    setFechaInicial: (state, { payload }) => {
      state.fini = payload;
    },
    setFechaIFin: (state, { payload }) => {
      state.ffin = payload;
    },
    setCasosUsuario: (state, { payload }) => {
      state.usercase = payload;
    },
    setCasosReporte: (state, { payload }) => {
      state.rpcase = payload;
    },
    setTypeUser: (state, { payload }) => {
      state.typeuser = payload;
    },
    setIsAdmin: (state, { payload }) => {
      state.isAdmin = payload;
    },
    setAgente: (state, { payload }) => {
      state.agente = payload;
    },
    setAdmin: (state, { payload }) => {
      state.admin = payload;
    },
    setCasoSelecionado: (state, { payload }) => {
      state.casoSeleccionado = payload;
    },
    setCasoNivelesSelecionado: (state, { payload }) => {
      state.casoNivelesSeleccionado = payload;
    },
    setDetallesCaso: (state, { payload }) => {
      state.detallesCaso = payload;
    },
    setOrganizaciones: (state, { payload }) => {
      state.organizaciones = payload;
    },
    setDependencias(state, action) {
      state.dependencias = action.payload;
    },
    setMatchGA(state, action) {
      state.matchGA = action.payload;
    },
    setFormulario(state, action) {
      state.formulario = action.payload;
    },
    setTypeMsj(state, action) {
      state.type_msj = action.payload;
    },
    resetDependencias(state) {
      state.dependencias = [];
      state.matchGA = true;
      state.formulario = "";
      state.type_msj = [];
      state.formInfo = {};
    },
    setFormInfo(state, { payload }) {
      state.formInfo = payload;
    },
    updFormInfo: (state, { payload }) => {
      state = Object.assign(state.formInfo, payload);
    },
    setPrioridad(state, { payload }) {
      state.prioridades = payload;
    },
    setUserReasignacionCaso(state, { payload }) {
      state.userreasignacioncaso = payload;
    },
  }
})

export const {  
  setLoadingHD,
  setFechaInicial,
  setFechaIFin,
  setCasosUsuario,
  setCasosReporte,
  setTypeUser,
  setIsAdmin,
  setAgente,
  setAdmin,
  setDetallesCaso,
  setCasoSelecionado,
  setCasoNivelesSelecionado,
  setOrganizaciones,
  setDependencias,
  setMatchGA,
  setFormulario,
  setTypeMsj,
  resetDependencias,
  setFormInfo,
  updFormInfo,
  setPrioridad,
  setUserReasignacionCaso
} = helpdeskSlice.actions;
